/**
 * @copyright KARD
 */

import React from "react";

import { navigate } from "@reach/router";

import { connect } from "react-redux";
import * as actions from "../../rdx/actions";
import Page from "../_common/page";

import "./sms.css";

/**
 */
const SmsCompose = (props) => {
  const [isLoading, IsLoading] = React.useState(false);

  const [listProj, ListProj] = React.useState([]);
  const [lastKey, LastKey] = React.useState(null);

  //
  return (
    <Page active="sms">
      <div className="row">
        <div className="col-sm-6">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">SMS Sent Items</a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">SMS Compose</a>
              </li>
            </ol>
          </nav>
        </div>
        <div className="col-sm-6 text-right">
          <p>Monday, 10 Augest 2021</p>
        </div>
      </div>

      <div className="row mt-2 mb-3">
        <div className="col">
          <h4 className="projectTitle m-0">
            <i className="fa fa-envelope fa-lg" /> SMS Compose
          </h4>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-9">
          <form>
            <div className="form-group">
              <label for="recipient-name" className="col-form-label">
                Recipients
              </label>
              <input
                type="text"
                className="form-control"
                id="recipient-name"
                placeholder="arif.hossain@elemelo.com"
              />
            </div>
            <div className="form-group">
              <label for="templateChoose" className="col-form-label">
                Template
              </label>
              <select class="form-control" id="templateChoose">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>
            <div className="form-group">
              <label for="email-subject" className="col-form-label">
                Subject
              </label>
              <input
                type="text"
                className="form-control"
                id="email-subject"
                placeholder="Ramadan Greetings"
              />
            </div>
            <div
              class="alert alert-primary alert-dismissible fade show text-primary"
              role="alert"
            >
              <strong>Holy guacamole!</strong> Auto merge possible only when
              selecting camping from address book.
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="form-group">
              <label for="sms_body" className="col-form-label">
                SMS Body
              </label>
              <textarea class="form-control" id="sms_body" rows="4"></textarea>
            </div>

            <button type="button" className="btn btn-primary">
              Send
            </button>
          </form>
        </div>

        <div className="col-sm-3">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title mb-0 ml-3">
                <i className="fa fa-address-card" /> Address Book
              </h4>
            </div>
            <div className="card-body pt-0">
              <ul className="contact-list">
                <li>
                  <div className="contact-cont">
                    <div className="float-left user-img m-r-10">
                      <a href="profile.html" title="Richard Miles">
                        <img
                          src="../assets/img/user.jpg"
                          alt=""
                          className="w-40 rounded-circle"
                        />
                      </a>
                    </div>
                    <div className="contact-info">
                      <span className="contact-date">
                        Abdul Karim / abdulkarim78@gmail.com
                      </span>
                      <span className="contact-name text-ellipsis">
                        +88 0175 444 5870
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="contact-cont">
                    <div className="float-left user-img m-r-10">
                      <a href="profile.html" title="Richard Miles">
                        <img
                          src="../assets/img/user.jpg"
                          alt=""
                          className="w-40 rounded-circle"
                        />
                      </a>
                    </div>
                    <div className="contact-info">
                      <span className="contact-date">
                        Abdul Karim / abdulkarim78@gmail.com
                      </span>
                      <span className="contact-name text-ellipsis">
                        +88 0175 444 5870
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="contact-cont">
                    <div className="float-left user-img m-r-10">
                      <a href="profile.html" title="Richard Miles">
                        <img
                          src="../assets/img/user.jpg"
                          alt=""
                          className="w-40 rounded-circle"
                        />
                      </a>
                    </div>
                    <div className="contact-info">
                      <span className="contact-date">
                        Abdul Karim / abdulkarim78@gmail.com
                      </span>
                      <span className="contact-name text-ellipsis">
                        +88 0175 444 5870
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="contact-cont">
                    <div className="float-left user-img m-r-10">
                      <a href="profile.html" title="Richard Miles">
                        <img
                          src="../assets/img/user.jpg"
                          alt=""
                          className="w-40 rounded-circle"
                        />
                      </a>
                    </div>
                    <div className="contact-info">
                      <span className="contact-date">
                        Abdul Karim / abdulkarim78@gmail.com
                      </span>
                      <span className="contact-name text-ellipsis">
                        +88 0175 444 5870
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}; // SmsCompose

/**
 */
const mapStateToProps = (state) => {
  return state;
}; //

/**
 */
export default connect(mapStateToProps, actions)(SmsCompose);
